import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
    AppBar, Avatar, Box, Chip, Divider, IconButton, Menu, MenuItem, Toolbar, Tooltip, Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAuth } from '../../context/AuthContext';

/**
 * AppBar van het administrator-gedeelte. Zelfde balk als de rest van de app,
 * met een "Administrator"-chip en — binnen een seizoen — een knop terug naar
 * het seizoenenoverzicht.
 */
function AdminAppBar({ season, onOpenNav }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClose = () => setAnchorEl(null);

    return (
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar sx={{ gap: 2 }}>
                {onOpenNav && (
                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={onOpenNav}
                        sx={{ display: { md: 'none' } }}
                        aria-label="Menu openen"
                    >
                        <MenuIcon />
                    </IconButton>
                )}

                <Box
                    component={RouterLink}
                    to="/admin"
                    sx={{ display: 'flex', alignItems: 'center', color: 'inherit', textDecoration: 'none' }}
                >
                    <img src="/logo192.png" alt="Spelveilingen logo" style={{ height: '60px', marginRight: '5px' }} />
                    <Typography variant="h6" component="div" sx={{ display: { xs: 'none', sm: 'block' } }}>
                        Spelveilingen
                    </Typography>
                </Box>

                <Chip
                    label="Administrator"
                    size="small"
                    variant="outlined"
                    color="primary"
                    sx={{ fontWeight: 700 }}
                />

                {season && (
                    <Chip
                        label={season.displayName || season.name}
                        onClick={() => navigate('/admin')}
                        deleteIcon={<ExpandMoreIcon />}
                        onDelete={() => navigate('/admin')}
                        variant="outlined"
                        sx={{ display: { xs: 'none', md: 'flex' }, color: 'inherit', borderRadius: 1 }}
                    />
                )}

                <Box sx={{ flexGrow: 1 }} />

                <Box>
                    <Tooltip title="Account instellingen">
                        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ p: 0 }}>
                            <Avatar>{(user?.name || user?.email || '').charAt(0).toUpperCase()}</Avatar>
                        </IconButton>
                    </Tooltip>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                        <MenuItem onClick={() => { navigate('/admin'); handleClose(); }}>Seizoenen</MenuItem>
                        <MenuItem onClick={() => { navigate('/admin/beheerders'); handleClose(); }}>Beheerders</MenuItem>
                        <Divider />
                        <MenuItem onClick={() => { navigate('/my-auctions'); handleClose(); }}>Mijn Veilingen</MenuItem>
                        <Divider />
                        <MenuItem onClick={() => { handleClose(); logout(); navigate('/'); }}>Uitloggen</MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default AdminAppBar;
